import { render, staticRenderFns } from "./HostawayNotificationDropdown.vue?vue&type=template&id=f046d328&"
import script from "./HostawayNotificationDropdown.vue?vue&type=script&lang=js&"
export * from "./HostawayNotificationDropdown.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports